module.exports = __webpack_public_path__ + "static/media/moile-viewdecor2.34b38f1b.png";